function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { GlobalStyles } from '@mui/material';
export var InputGlobalStyles = /*#__PURE__*/ _jsx(GlobalStyles, {
    styles: function(theme) {
        return {
            'p,a': {
                fontSize: '1.6rem',
                lineHeight: 'inherit',
                marginBottom: theme.spacing(2)
            },
            a: {
                color: 'inherit',
                textDecoration: 'none',
                padding: "0 ".concat(theme.spacing(0.5)),
                '&:hover': {
                    textDecoration: 'underline'
                }
            },
            '.text-list': {
                paddingLeft: theme.spacing(2),
                marginBottom: theme.spacing(2)
            },
            '.scroll-box': {
                height: '100%',
                overflowY: 'auto',
                overflowX: 'hidden',
                position: 'relative'
            },
            '.container-regular': _define_property({
                paddingInline: theme.spacing(2)
            }, theme.breakpoints.up('sm'), {
                paddingInline: theme.spacing(4)
            }),
            '.is-sticky': {
                position: 'sticky',
                top: 0
            },
            'li:has(.MuiListItemText-root > .MuiTypography-root:empty)': {
                display: 'none !important'
            },
            '.MuiTypography-root:empty': {
                display: 'none !important'
            },
            '.page-break': {
                width: '100%',
                height: 0
            },
            'input:not(.counter)::-webkit-outer-spin-button, input:not(.counter)::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none'
            },
            'input[type="number"]': {
                '-moz-appearance': 'textfield'
            }
        };
    }
});
